"use client";

import Image from "next/image";
import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import "./MobileHeroSection.scss";

const MobileHeroSection = ({ hero }) => {
  if (!hero) return null;

  const { title, description, statItems = [], image } = hero;

  const { ref, inView } = useInView({
    threshold: 0.4,
    triggerOnce: false,
  });

  const formattedStats = statItems.map((stat) => ({
    ...stat,
    value: parseFloat(stat.value),
    suffix: stat.value.replace(/[0-9.]/g, ""),
    decimals: stat.value.includes(".") ? 1 : 0,
  }));

  return (
    <section className="mobile-hero-section" ref={ref}>
      <Container>
        <Row className="align-items-center">
          <Col lg={6} md={6} className="mb-5 mb-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, ease: "easeOut" }}
            >
              <h1 className="mobile-hero-title">{title}</h1>
            </motion.div>

            <motion.p
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mobile-hero-description"
            >
              {description}
            </motion.p>

            <div className="mobile-hero-stats">
              {formattedStats.map((stat, index) => (
                <motion.div
                  key={`${stat.label}-${stat.value}-${index}`}
                  className="mobile-stat-item"
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: index * 0.15 + 0.3,
                    duration: 0.5,
                  }}
                >
                  <span className="mobile-stat-value">
                    {inView ? (
                      <CountUp
                        end={stat.value}
                        duration={2}
                        decimals={stat.decimals}
                      />
                    ) : (
                      0
                    )}
                    {stat.suffix}
                  </span>

                  <span className="mobile-stat-label">{stat.label}</span>

                  {index !== formattedStats.length - 1 && (
                    <div className="mobile-stat-divider" />
                  )}
                </motion.div>
              ))}
            </div>
          </Col>

          <Col lg={6} md={6} className="mobile-hero-image-col">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7 }}
              className="mobile-image-wrapper"
            >
              <Image
                src={image}
                alt={title}
                fill
                className="mobile-hero-image"
                priority
              />
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default MobileHeroSection;
